"use client";

import { useSearchParams } from "next/navigation";
import Script from "next/script";
import { useEffect, use } from "react";
import { saveCouponToStorage } from "@/lib/utils";
import { TranslationProvider } from "@/components/providers/translation-provider";

export default function LayoutLanguage({ children, params: paramsPromise }) {
  const params = use(paramsPromise);
  const searchParams = useSearchParams();

  // Check for coupon code in URL and save to localStorage
  useEffect(() => {
    const couponParam = searchParams.get("coupon");
    if (couponParam) {
      saveCouponToStorage(couponParam);
    }
  }, [searchParams]);
  return (
    <TranslationProvider
      namespaces={["public_signup", "public_signin", "public_password_reset"]}
      locale={params?.locale}
      withoutUserId={true}
    >
      {children}
      {process.env.NODE_ENV === "production" && (
        <Script
          id="hubspot-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
          (function() {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//js-na1.hs-scripts.com/5825609.js';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
          })();
        `,
          }}
        />
      )}
    </TranslationProvider>
  );
}
